import React from 'react';
import {Row, Col, FormGroup, Input, Card, Label, Button, CardBody, CardHeader} from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressBar } from 'primereact/progressbar';
import { useReportCxc } from '../../../hooks/reportCxc/useReportCxc';
import { ToastAletGlobal } from '../../alertDialog/ToastAletGlobal';
import Select from 'react-select';

export const IndexReportGlobalCxc = () => {

    const {
        start_date,
        end_date,
        handleInputChange,
        filteredReports,
        isDownloading,
        isButtonDisabled,
        generateReportCxC,
        downloadReportCxC,
        searchTerm,
        setSearchTerm,
        visualProgress,
        listCompanies,
        id_company,
        handleChangeClient,

        listAgreements,
        idAgreementCompany,
        handleChangeAgreement,

        
        //? TOAST ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        showToastAlert,
        closeToastAlert,

    } = useReportCxc();


    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
        textAlign: "center"
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };

    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '35px',
            borderRadius: '5px',
            borderColor: state.isFocused
                ? '#46AFE5'
                : '#dbe4f0',
            boxShadow: state.isFocused
                ? '0 0 0 3px rgba(70,175,229,.15)'
                : 'none',
                fontSize: '12px',
            transition: 'all .2s ease',
            '&:hover': {
                borderColor: '#46AFE5'
            }
            
        }),

        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? '#46AFE5'
                : state.isFocused
                    ? '#eef7fd'
                    : '#fff',
            color: state.isSelected ? '#fff' : '#334155',
            cursor: 'pointer'
        }),

        placeholder: (provided) => ({
            ...provided,
            color: '#94a3b8'
        }),

        menuPortal: (base) => ({
            ...base,
            zIndex: 999999
            }),

            menu: (provided) => ({
                ...provided,
                zIndex: 999999,
                position: 'absolute'
        }),

    };

    const progressTemplate = (rowData) => {
        const backendProgress = Number(rowData.progress) || 0;

        const progress =
            backendProgress >= 100
                ? 100
                : visualProgress[rowData.id_report_cxc_download] ?? 5;

        if (progress >= 100) {
            return (
                <span
                    style={{
                        backgroundColor: "#28a745",
                        color: "#fff",
                        padding: "5px 12px",
                        borderRadius: "12px",
                        fontWeight: "bold",
                        fontSize: "12px",
                        display: "inline-block"
                    }}
                >
                    <i className="fa fa-check-circle mr-1"></i>
                    Completado
                </span>
            );
        }

        return (
            <div style={{width: "140px", margin: "0 auto"}}>
                <ProgressBar
                    value={progress}
                    showValue
                    style={{height: "16px", borderRadius: "10px"}}
                />

                <small style={{fontSize: "11px", color: "#363535"}}>
                    {progress < 30
                        ? "Preparando..."
                        : progress < 60
                            ? "Procesando..."
                            : progress < 85
                                ? "Generando Excel..."
                                : "Finalizando..."}
                </small>
            </div>
        );
    };

    const actionsTemplate = (row) => {
        const progress = Number(row.progress) || 0;
        const isDisabled = progress < 100 || !row.download_filename;
        return (
            <div className="d-flex justify-content-center align-items-center" style={{gap: "5px"}}>
                <button 
                    type="button"
                    disabled={isDisabled}
                    title={isDisabled ? "El reporte todavía se está generando" : "Descargar reporte"}
                    onClick={() => downloadReportCxC(row)}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "28px",
                        width: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "none",
                        borderRadius: "5px",
                        backgroundColor:
                            isDisabled
                                ? "#d3d3d3"
                                : "#075488",

                        color:
                            isDisabled
                                ? "#888"
                                : "#fff",

                        cursor:
                            isDisabled
                                ? "not-allowed"
                                : "pointer",

                        opacity:
                            isDisabled
                                ? 0.7
                                : 1
                    }}
                >
                    <i className="fa fa-download"></i>
                </button>
            </div>
        );
    };

    let typeMenu = localStorage.getItem('menu') === "True";

    return (

        <>
            <div className='container-global-zoom'>
                <Card style={{marginBottom: "15px", background:"linear-gradient(135deg, #002940 0%, #1d5b83 100%)", border: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.15)"}}>
                    <CardBody style={{padding: "18px 25px"}}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div style={{width: "50px", height: "50px", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center",marginRight: "15px"}}>
                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/laboratory-External/icon-logs.svg")} style={{width: "60px", height: "60px"}}/>
                                </div>

                                <div>
                                    <h4 className="mb-1" style={{color: "#fff", fontWeight: 700, fontSize: "20px", textAlign: "justify"}}>
                                        Reporte Global de Cuentas por Cobrar
                                    </h4>

                                    <small style={{color:"rgba(255,255,255,0.85)", fontSize: "13px"}}>
                                        <i className="fa fa-info-circle mr-1"></i>
                                        Genera y descarga reportes detallado de las cuentas por cobrar, incluyendo la información de los clientes, convenios, saldos y movimientos correspondientes al periodo seleccionado.
                                    </small>
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </div>

            <Card className='shadow-sm border height-equal pricingtable mb-0 container-global-zoom'>
                <Col className={`${typeMenu ? "p-1" : ""}`} sm="12" >
                    <Row>
                        <Col sm="2" className='p-l-0 p-r-0' style={{textAlign: "left"}}>
                            <Card style={{boxShadow: '0 4px 12px rgba(0,0,0,0.1)', border: 'none', height: '100%', borderRadius: '12px'}}>
                                <CardHeader style={{ background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)', color: 'white', padding: '15px', borderRadius:'12px 12px 0 0' }}>
                                    <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px'}}>
                                        <i className="fa fa-filter mr-2"></i>
                                        Filtros de Búsqueda
                                    </h6>
                                </CardHeader>

                                <CardBody style={{padding: '20px'}}>
                                    <FormGroup>
                                        <Label className='f-w-600 label-report'>
                                            Fecha de inicio
                                        </Label>

                                        <Input
                                            type="date"
                                            name="start_date"
                                            value={start_date}
                                            onChange={handleInputChange}
                                            className='form-control'
                                            style={{borderRadius: '8px', border:'1px solid #ddd', padding: '10px', fontSize: '13px'}}
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label className='f-w-600 label-report'>
                                            Fecha de cierre
                                        </Label>

                                        <Input
                                            type="date"
                                            name="end_date"
                                            value={end_date}
                                            onChange={handleInputChange}
                                            className='form-control'
                                            style={{borderRadius: '8px', border:'1px solid #ddd', padding: '10px', fontSize: '13px'}}
                                        />
                                    </FormGroup>

                                   <FormGroup>
                                        <Label className='f-w-600 label-report'>
                                            Cliente
                                        </Label>

                                        <Select
                                            name="id_company"
                                            value={id_company}
                                            options={listCompanies}
                                            onChange={handleChangeClient}
                                            placeholder="Seleccione una empresa"
                                            isClearable
                                            styles={customSelectStyles}
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label className='f-w-600 label-report'>
                                            Convenio
                                        </Label>

                                        <Select
                                            name="idAgreementCompany"
                                            options={listAgreements}
                                            value={idAgreementCompany}
                                            onChange={handleChangeAgreement}
                                            placeholder={
                                                id_company
                                                    ? "Seleccione un convenio"
                                                    : "Seleccione primero una empresa"
                                            }
                                            isDisabled={!id_company}
                                            isClearable
                                            styles={customSelectStyles}
                                        />
                                    </FormGroup>

                                    <b>Acciones</b>
                                    <br />
                                    <br />
                                    <Button
                                        onClick={generateReportCxC}
                                        disabled={isButtonDisabled}
                                        color="primary"
                                        block
                                        outline
                                        className="mb-3"
                                        style={{borderRadius: '10px', padding: '6px', fontSize: '14px', fontWeight: 600,borderWidth: '2px'}}
                                    >
                                        {
                                            isDownloading ? (
                                                <>
                                                    <i className="fa fa-spinner fa-spin mr-2"></i>
                                                    Generando...
                                                </>
                                            )
                                            :
                                            (
                                                <>
                                                    <i className="fa fa-file-excel-o mr-2"></i>
                                                    Generar reporte
                                                </>
                                            )
                                        }
                                    </Button>
                                </CardBody>
                            </Card>
                        </Col>
        
                        <Col sm="10" className='pl-4'>
                            <div style={{position: "relative", width: "100%", height: "50px"}}>
                                <div className="ribbon ribbon-clip ribbon-primary" style={{top: "8px", left: "0px", zIndex: 10}}>
                                    Reportes generados
                                </div>

                                <div style={{position: "absolute", right: "0", top: "5px", width: "280px" }}>
                                    <Input
                                        type="search"
                                        placeholder="Buscar..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        style={{
                                            width: "100%",
                                            height: "39px",
                                            borderRadius: "8px",
                                            border: "1px solid #78bffa",
                                            paddingLeft: "15px",
                                            paddingRight: "10px",
                                            fontSize: "13px"
                                        }}
                                    />
                                </div>
                            </div>

                            <DataTable
                                value={filteredReports}
                                paginator
                                rows={10}
                                responsiveLayout="scroll"
                                className="data-table p-datatable-striped p-datatable-sm"
                                rowsPerPageOptions={[10, 50, 100]}
                                loading={isDownloading}
                                emptyMessage={
                                    <div className="text-center">
                                        <img
                                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                            style={{ width: "25%" }}
                                            alt="Sin resultados"
                                        />
                                        <br />

                                        <p
                                            className="badge badge-light-primary mt-2"
                                            style={{ fontSize: "15px" }}
                                        >
                                            Sin resultados.
                                        </p>
                                    </div>
                                }
                            >
                                <Column
                                    body={(rowData, { rowIndex }) => rowIndex + 1}
                                    header="#"
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />

                                <Column
                                    field="from"
                                    header="Fecha Inicio"
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />

                                <Column
                                    field="to"
                                    header="Fecha Fin"
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />

                                <Column
                                    field="company"
                                    header="Empresa"
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />

                                <Column
                                    field="agreement"
                                    header="Convenio"
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />

                                <Column
                                    field="ended_at"
                                    header="Fecha de Generación"
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />

                                <Column
                                    field="user"
                                    header="Usuario"
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />

                                <Column
                                    header="Proceso"
                                    body={progressTemplate}
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />

                                <Column
                                    header="Acciones"
                                    body={actionsTemplate}
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />
                            </DataTable>

                        </Col>
                    </Row>
                </Col>
            </Card>

            <ToastAletGlobal
                visible={showToast}
                type={toastType}
                title={toastTitle}
                message={toastMessage}
                onClose={closeToastAlert}
            />
        </>
    );
};